// --------------------------- Global
window.theme = window.theme || {};

// jQuery as a global module
import "./global.js";

// --------------------------- Helpers / Polyfills

// Helper : Old Browsers
import "./helpers/polyfills.js";

// Helper : General
import "./helpers/helpers.js";

// --------------------------- Modules

// Module : Menus
import "./modules/menus.js";

// Module : Accordion
import "./modules/accordion.js";

// Module : Match height
import "./modules/match-height.js";

// Module : Tabs
import "./modules/tabs.js";

// Module : Mega Menu
import "./modules/mega-menu.js";

// Module : Media
import "./modules/media.js";

// Module : Swiper
import "./modules/swiper.js";

// Module : Modal
import "./modules/modal.js";

// --------------------------- Shopify

// Module : Account
import "./shopify/account.js";

// Module : Cart
import "./shopify/cart.js";

// Module : Currency
import "./shopify/currency.js";

// Module : General
import "./shopify/general.js";

// Theme : Recently Viewed
import "./shopify/recently-viewed.js";

// Module : Variants
import "./shopify/variants.custom.js";
import "./shopify/variants.js";

// Module : Wishlist
import "./shopify/wishlist.js";

// Module : Filter
import "./shopify/filter.js";
